import { ICourse } from '@/types/course'
import { IUser } from '@/types/user'
import { ParsedUrlQuery } from 'querystring'

export const sendSearchViewEvent = (routerQuery: ParsedUrlQuery) => {
  if (typeof window !== 'undefined') {
    const tags = (
      Array.isArray(routerQuery.tags) ? routerQuery.tags : [routerQuery.tags]
    ).filter(Boolean)

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'search_courses',
      queryParamTags: tags,
      queryParamTagsCsv: tags.join(','),
    })
  }
}

export const sendCourseViewEvent = (course: Partial<ICourse>) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'course_view',
      name: course.name,
      courseId: course._id,
      courseTags:
        course.tags?.map((tag) => (typeof tag === 'string' ? tag : tag.slug)) ??
        [],
      courseTagsCsv:
        course.tags
          ?.map((tag) => (typeof tag === 'string' ? tag : tag.slug))
          .join(',') ?? '',
    })
  }
}

export const sendUserSignUpAnalyticsEvent = (user: Partial<IUser>) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'user_sign_up',
      userId: user._id,
    })
  }
}
